import apiClient from './index';

export interface UserDocket {
  previewUrl: string;
  version: number;
  generatedAt: string | null;
}

/**
 * Read-only docket for the applicant (basic tier). Resolves with the signed
 * download URL when a docket has been generated; rejects (404/403) otherwise —
 * premium packages are filed by LGV and return 403 HANDLED_BY_LGV.
 */
export const getUserDocket = async (applicationId: number): Promise<UserDocket> => {
  const res = await apiClient.get(`/applications/${applicationId}/docket`);
  return res.data.data;
};
